import getBeneficiariesModuleStatus from 'features/Onboarding/modules/Beneficiaries/libs/getBeneficiariesModuleStatus';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { State } from '../../machine';
import model from '../../machine/model';
import locales from './locales';
import {
  GetVerificationStep,
  VerificationStatus,
  VerificationStepCategory,
} from './types';

const getBeneficiariesStep: GetVerificationStep = ({
  applicantType,
  applicationType,
  isMainApplicant,
  verificationData,
}) => {
  const {
    legalBeneficiaries = [],
    metadata: { hasRegisteredAllBeneficiaries },
    profile: { legalForm },
  } = verificationData.viewer.company;

  const status = getBeneficiariesModuleStatus({
    hasRegisteredAllBeneficiaries,
    isMainApplicant,
    legalBeneficiaries,
    legalForm,
  });

  const isOnboardingHub =
    applicationType === ApplicationType.Standard &&
    applicantType === ApplicantType.AccountHolder;

  return {
    errors:
      status === VerificationStatus.Invalid
        ? [locales.registerBeneficiaries.invalid]
        : [],
    id: State.BENEFICIARIES_REGISTER,
    metadata: {
      category: VerificationStepCategory.CompanyInfo,
      event: model.events.GO_BENEFICIARIES_REGISTER(),
      iconName: 'team',
      isDisabled: !isOnboardingHub && status === VerificationStatus.Completed,
      label: locales.registerBeneficiaries.label,
    },
    status,
  };
};

export default getBeneficiariesStep;
